import React, { useState, useEffect, useMemo } from "react";
import { useLocation } from "react-router-dom";
import moment from "moment";
import AccessTimeRoundedIcon from "@material-ui/icons/AccessTimeRounded";
import LanguageRoundedIcon from "@material-ui/icons/LanguageRounded";
import styles from "./Footer.module.css";
import FabButton from "../Fab/Fab";
import { detectSystemTimezone, shortZoneCity, getZoneOffsetLabel } from "../../Context/TimezoneContext";

const Footer = () => {
  const location = useLocation();
  const [user, setUser] = useState(() => {
    const raw = localStorage.getItem("profile");
    return raw ? JSON.parse(raw) : null;
  });
  const profileRawRef = React.useRef(localStorage.getItem("profile"));
  useEffect(() => {
    const raw = localStorage.getItem("profile");
    if (raw === profileRawRef.current) return;
    profileRawRef.current = raw;
    setUser(raw ? JSON.parse(raw) : null);
  }, [location]);

  // Live clock, ticking every second - "15 Aug 2026" date style, 12-hour
  // clock with AM/PM and seconds, the way retail till software usually
  // shows the current date/time.
  const [now, setNow] = useState(() => moment());
  useEffect(() => {
    const id = setInterval(() => setNow(moment()), 1000);
    return () => clearInterval(id);
  }, []);

  // PosMainScreen renders its own <FabButton /> directly, so don't render
  // a second one here — the footer bar itself still shows on every page.
  const isPosScreen =
    location.pathname === "/PosMainScreen" ||
    location.pathname.startsWith("/edit/invoice");

  // This device's own OS/browser timezone, shown publicly for every user -
  // not a preference, just a label so anyone glancing at the clock knows
  // what zone it's in. A device's own timezone doesn't change mid-session,
  // so this only needs to be read once (see Context/TimezoneContext.js).
  const systemTimezone = useMemo(() => detectSystemTimezone(), []);

  return (
    <footer className={styles.footer}>
      <div className={styles.content}>
        <span className={styles.statusDot} aria-hidden="true" />
        <span>
          Powered by <strong>Mindtree Technologies Co. Ltd.</strong>
        </span>
      </div>

      <div className={styles.timezone} title={systemTimezone} aria-label={`Timezone: ${systemTimezone}`}>
        <LanguageRoundedIcon className={styles.zoneIcon} />
        <span>{shortZoneCity(systemTimezone)}</span>
        <span className={styles.zoneOffset}>{getZoneOffsetLabel(systemTimezone, now.toDate())}</span>
      </div>

      <div className={styles.clock} aria-label={`Current date and time in ${systemTimezone}`}>
        <AccessTimeRoundedIcon className={styles.clockIcon} />
        <span className={styles.clockDate}>{now.format("MMM DD, YYYY")}</span>
        <span className={styles.clockDivider}>•</span>
        <span className={styles.clockTime}>{now.format("hh:mm:ss A")}</span>
        <span className={styles.clockDivider}>•</span>
      </div>

      {user && !isPosScreen && <FabButton />}
    </footer>
  );
};

export default Footer;
